import React from 'react';
import Check from "../../assets/images/check_green.png";

interface Props {
  show: boolean;
  setShowModal: (show: boolean) => void;
}

const Congratulations: React.FC<Props> = ({ show, setShowModal }) => {
  return (
    <div className='Congratmodal'>
      <div className="modal" style={show ? { display: "block" } : { display: "none" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button 
                type="button" 
                className="btn-close" 
                data-bs-dismiss="modal" 
                aria-label="Close" 
                onClick={() => {
                  setShowModal(false);
                }}
              >
                <i></i>
              </button>
            </div>
            <div className="modal-body" style={{paddingTop: "0 !important"}}>
              <div className='conText text-center'>
                <img src={Check} alt="" className='img-fluid' width={100} height={100} />
                <h5 className='text-black mt-3'>Thank You!</h5>
                <p>
                  <b>You'll receive your eSIM QR code via email shortly.</b><br/>
                  Safe travels and enjoy your stay in Singapore!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Congratulations;
